import { render } from "./PlayerProfile.vue?vue&type=template&id=4a1387eb"
import script from "./PlayerProfile.vue?vue&type=script&lang=js"
export * from "./PlayerProfile.vue?vue&type=script&lang=js"

import "./PlayerProfile.vue?vue&type=style&index=0&id=4a1387eb&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__